import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNoneSpecialChar]',
  standalone: true,
})
export class NoneSpecialCharDirective {
  regexStr = '^[@$%^()+=/"<>|]*$';
  regexNew = new RegExp(this.regexStr);
  @Input('appNoneSpecialChar') on = false;

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: { key: string }) {
    if (!this.on) return;
    return !this.regexNew.test(event.key);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    if (!this.on) return;
    this.validateFields(event);
  }

  @HostListener('blur', ['$event']) onBlur(event: Event) {
    if (!this.on) return;
    this.validateFields(event);
  }

  validateFields(event: KeyboardEvent | Event) {
    setTimeout(() => {
      this.el.nativeElement.value = this.el.nativeElement.value
        .trim()
        .replace(/[@$%^()+=/"<>|]/g, '')
        .replace(/  +/g, ' ');
      event.preventDefault();
    }, 100);
  }
}
